/*--------------------------------------------------------------
# Custom scripts for faqs
--------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll(".faq-accordion");

    accordions.forEach(function (accordion) {
        const accordionId = accordion.id;
        const items = accordion.querySelectorAll(".accordion-collapse");

        items.forEach(function (item) {
            item.setAttribute("data-bs-parent", "#" + accordionId);
            
            // Prevent clicks inside accordion body from triggering collapse
            // Only apply when video-block or wp-block-video class is present
            // This ensures only the button can toggle the accordion when videos are present
            const accordionBody = item.querySelector(".accordion-body");
            if (accordionBody) {
                // Check if accordion body contains video-block or wp-block-video
                const hasVideoBlock = accordionBody.querySelector(".video-block, .wp-block-video, .vimeo-showcase");
                
                if (hasVideoBlock) {
                    accordionBody.addEventListener("click", function (e) {
                        // Stop event propagation to prevent collapse from being triggered
                        e.stopPropagation();
                    });
                    // Pause videos when accordion collapses
                    item.addEventListener("hidden.bs.collapse", function () {
                        pauseVideosInElement(item);
                    });
                }
            }            
        });
    });
    
    /**
     * Pause all videos (video tags and iframes) within an element
     * @param {HTMLElement} element - The element to search for videos
     */
    function pauseVideosInElement(element) {
        // Pause native video elements
        const videoElements = element.querySelectorAll("video");
        videoElements.forEach(function (video) {
            if (!video.paused) {
                video.pause();
            }
        });
        
        // Pause iframe videos (YouTube, Vimeo, etc.)
        const iframes = element.querySelectorAll("iframe");
        iframes.forEach(function (iframe) {
            const iframeSrc = iframe.src || "";
            
            // YouTube - use YouTube IFrame API to pause without reloading
            if (iframeSrc.includes("youtube.com") || iframeSrc.includes("youtu.be")) {
                try {
                    // Send pause command via postMessage - this preserves video position
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } catch (e) {
                    console.warn("Could not pause YouTube video:", e);
                }
            }
            // Vimeo - use Vimeo Player API to pause without reloading
            // Works for both regular Vimeo videos and Vimeo showcases (e.g., vimeo.com/showcase/...)
            else if (iframeSrc.includes("vimeo.com")) {
                try {
                    // Send pause command via postMessage - this preserves video position
                    // Vimeo Player API works for regular videos, showcases, and other embed types
                    // Use wildcard origin to support all Vimeo embed variations
                    iframe.contentWindow.postMessage(JSON.stringify({ method: "pause" }), '*');
                } catch (e) {
                    console.warn("Could not pause Vimeo video:", e);
                }
            }
            // Note: Other video players are not handled to avoid reloading videos
        });
    }
});

/////////////////////////////////////////////////////////////////////////
// START - auto scroll to top of viewport when collapsse

// Offset height for scrolling (e.g. to account for fixed header)
const offsetHeight = 20;

// Select all accordion items to be focused
const accordionItemsToBeFocused = document.querySelectorAll(".collapse");

// For each accordion item
accordionItemsToBeFocused.forEach((el) => {
    // Remove this functionality from the #navigation-primary

    if (el.getAttribute("data-no-focus")) {
        return;
    }

    // Prevent page jump/hash update for FAQ accordions.
    if (el.closest(".faq-accordion") || el.closest(".yoast-faq-accordion")) {
        return;
    }

    // Set scroll margin to account for offset (e.g. fixed header)
    el.style.scrollMarginTop = `${offsetHeight}px`;

    // Listen for Bootstrap's collapse event
    el.addEventListener("shown.bs.collapse", (e) => {
        // Exit is any primary navigation triggers are clicked.
        if (el.classList.contains("dd-menu-type-dropdown") || el.classList.contains("header-search") || el.classList.contains("language-menu")) {
            return;
        }
        // Scroll to the opened accordion item
        window.location.href = `#${el.id}`;
    });
});
// END - auto scroll to top of viewport when collapsse
///////////////////////////////////////////////////////////////////////